// removed by extract-text-webpack-plugin
module.exports = {"alert":"_3q5r0HHaTncb8z5-XVky93","success":"_2MYYEPTfc-14BBhnvihqVH","warning":"_3R9jxW4L3NhOAGkRRwtxrx","danger":"_1eslilCzcez_RHxssn_tuq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Alert/style.css
// module id = 240
// module chunks = 42